export default "__VITE_ASSET__DJ6jmsQz__"